<template lang="html">
  <div>
    <br>

    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Título -->
        <v-layout row>
          <v-flex xs9>
            <c-readonly-field 
            label="Título" 
            :value="this.projetoPesquisa.titulo ? this.projetoPesquisa.titulo : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Sigla -->
        <v-layout row>
          <v-flex xs2>
            <c-readonly-field 
            label="Sigla" 
            :value="this.projetoPesquisa.sigla ? this.projetoPesquisa.sigla : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Área do Conhecimento e Nome da Área -->
        <v-layout row>

          <!-- Área do Conhecimento -->
          <v-flex xs6>
            <c-readonly-field 
            label="Área do Conhecimento" 
            :value="this.projetoPesquisa.areaConhecimento ? this.projetoPesquisa.areaConhecimento.descricao : '-'"
            ></c-readonly-field>
          </v-flex>

          <!-- Nome da Área -->
          <v-flex xs6>
            <c-readonly-field 
            label="Nome da Área" 
            :value="this.projetoPesquisa.nomeArea ? this.projetoPesquisa.nomeArea.descricao : '-'"
            ></c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Nome da Subárea e Linha de Pesquisa no Programa de Pós-Graduação -->
        <v-layout row>

          <!-- Nome da Subárea -->
          <v-flex xs6>
            <c-readonly-field 
            label="Nome da Subárea" 
            :value="this.projetoPesquisa.nomeSubarea ? this.projetoPesquisa.nomeSubarea.descricao: '-'"
            ></c-readonly-field>
          </v-flex>

          <!-- Linha de Pesquisa no Programa de Pós-Graduação -->
          <v-flex xs6>
            <c-readonly-field 
            label="Linha de Pesquisa no Programa de Pós-Graduação" 
            :value="this.projetoPesquisa.linhaPesquisaPPG ? this.projetoPesquisa.linhaPesquisaPPG.descricao : '-'"
            ></c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Data de início e Prazo em meses -->
        <v-layout row>

          <!-- Data de início -->
          <v-flex xs6>
            <c-readonly-field 
            label="Data de início" 
            :value="this.projetoPesquisa.dataInicio ? dates.format(this.projetoPesquisa.dataInicio) : '-'"
            ></c-readonly-field>
          </v-flex>

          <!-- Prazo em meses -->
          <v-flex xs6>
            <c-readonly-field 
            label="Prazo em meses" 
            :value="this.projetoPesquisa.prazoMeses ? this.projetoPesquisa.prazoMeses : '-'"
            ></c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Situação -->
        <v-layout row>

          <!-- Situação -->
          <v-flex xs6>
            <c-readonly-field 
            label="Situação" 
            :value="this.projetoPesquisa.situacao ? this.projetoPesquisa.situacao.descricao : '-'"
            ></c-readonly-field>
          </v-flex>
          
        </v-layout>

        <!-- Palavras-chaves -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Palavras-chaves" 
            :value="this.projetoPesquisa.palavrasChaves ? this.projetoPesquisa.palavrasChaves : '-'" 
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Resumo -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Resumo" 
            :value="this.projetoPesquisa.resumo ? this.projetoPesquisa.resumo : '-'" 
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <br>

      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <!-- Botão "Editar" -->
      <v-btn color="primary" @click="toEditar()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Editar</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()" v-if="habilitaBotaoAvancar()">Avançar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dates: dates
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },

    // Habilita botão "Avançar".
    habilitaBotaoAvancar: function () {
      if (this.situacaoCancelado() === true && this.administradorPRPPG !== true && this.projetoPesquisa.coordenador !== true) {
        return false
      } else {
        return true
      }
    },

    // Edita a aba "Informações Básicas".
    toEditar: function () {
      this.$router.push({ name: 'EditarProjetoPesquisaInformacoesBasicas', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-readonly-field': ReadonlyField
  }
}
</script>



// WEBPACK FOOTER //
// informacoes-basicas.vue?348ff074